import state from './globalactionmember.state'
import mutations from './globalactionmember.mutations'
import actions from './globalactionmember.actions'

export default {
  state,
  mutations,
  actions
}
